import { ERROR, RESET, SET_SAVE_SUCCESS, SET_SERVICE, SET_SERVICE_TYPE_LOADING_STATUS } from './ViewServiceConstants'

export function resetViewServiceState() {
  return {
    type: RESET,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setService(service) {
  return {
    type: SET_SERVICE,
    payload: service,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setSaveSuccess(newStatus) {
  return {
    type: SET_SAVE_SUCCESS,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setServiceTypeLoading(newStatus) {
  return {
    type: SET_SERVICE_TYPE_LOADING_STATUS,
    payload: newStatus,
  }
}

export function setError(code = '', extra = null) {
  return {
    type: ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}
